import qs from "qs";
import { formatDate } from "../utils/DateUtils";
import { GetAccessToken } from "../utils/AuthUtils";
import dotenv from "dotenv";
dotenv.config();

let apiUrl;
if (process.env.NODE_ENV === "production") {
  apiUrl = `${process.env.REACT_APP_SITE_URL}`;
} else {
  apiUrl = `${process.env.REACT_APP_BASE_URL}:${process.env.REACT_APP_PORT}`;
}

export default function setupAxios(axios, store) {
  axios.default.paramsSerializer = (params) => {
    return qs.stringify(params, {
      serializeDate: (date) => {
        console.log("axios " + date);
        formatDate(date);
      },
    });
  };

  axios.interceptors.request.use(
    (conf) => {
      if (
        conf.url !==
        `${apiUrl}${process.env.REACT_APP_GET_ACCESS_TOKEN_ENDPOINT}${process.env.REACT_APP_GET_ACCESS_TOKEN_CODE}`
      ) {
        const accessToken = GetAccessToken();

        if (accessToken) {
          conf.headers.Authorization = `Bearer ${accessToken}`;
          // conf.headers["X-Gravitee-Api-Key"] = config.apikey;
        } else {
          window.alert(
            "La sessione attuale è scaduta, la pagina verrà ricaricata"
          );
          window.sessionStorage.clear();
          window.location.reload();
        }
      }

      return conf;
    },

    (err) => Promise.reject(err)
  );
}
